import React from 'react';
import { HiCheckCircle } from 'react-icons/hi';
import Avatar from '../Avatar';
import Tipseen from '../Tipseen';
import {
  UserStatusWrapper,
  WrapperRightComponentBar,
  UserStatusButton,
  ProgressParticipantWrapper,
  ProgressParticipants,
  ParticipantsCount,
  AvatarGroup,
} from './style';

function Participants({
  membersBar,
  currentUserDone,
  totalMembers,
  popupMembers,
}) {
  return (
    <>
      {membersBar.map((p, memberIndex) => (
        <Avatar
          // eslint-disable-next-line react/no-array-index-key
          key={`user-status-${memberIndex}`}
          badge={<HiCheckCircle />}
          showBadge={memberIndex === 0 ? currentUserDone : p.done}
          src={p.photo_thumb}
          order={memberIndex}
          group={totalMembers >= 1}
          border
          color="bgCard"
          colorWithBadge="green"
        />
      ))}
      {popupMembers.length > 0 && (
        <Tipseen placement="top">
          {popupMembers.map((p, popupMemberIndex) => (
            <Avatar
              key={p.photo_thumb}
              badge={<HiCheckCircle />}
              showBadge={p.done}
              border
              order={popupMemberIndex}
              src={p.photo_thumb}
              color="white"
              colorWithBadge="green"
            />
          ))}

          <Avatar defaultValue={`+${popupMembers.length}`} link group />
        </Tipseen>
      )}
    </>
  );
}

function UserStatus({
  membersBar,
  popupMembers,
  handleCurrentUserDone,
  currentUserDone,
}) {
  const totalMembers = membersBar.length + popupMembers.length;
  const totalMembersDone =
    membersBar.reduce(
      (accumulator, member, memberIndex) =>
        member.done && memberIndex !== 0 ? accumulator + 1 : accumulator,
      0
    ) +
    popupMembers.reduce(
      (accumulator, member) => (member.done ? accumulator + 1 : accumulator),
      0
    ) +
    (currentUserDone ? 1 : 0);

  return (
    totalMembers > 0 && (
      <UserStatusWrapper>
        <AvatarGroup group>
          <Participants
            membersBar={membersBar}
            currentUserDone={currentUserDone}
            totalMembers={totalMembers}
            popupMembers={popupMembers}
          />
        </AvatarGroup>
        <WrapperRightComponentBar>
          <ParticipantsCount>
            <div>
              {totalMembersDone}/{totalMembers} participants finished
            </div>
            <ProgressParticipantWrapper>
              <ProgressParticipants
                progress={totalMembersDone / totalMembers}
              />
            </ProgressParticipantWrapper>
          </ParticipantsCount>
          <UserStatusButton
            done={currentUserDone}
            size="md"
            onClick={handleCurrentUserDone}
          >
            I'm finished
          </UserStatusButton>
        </WrapperRightComponentBar>
      </UserStatusWrapper>
    )
  );
}

export default UserStatus;
